import Vue from "vue";
import Toaster from 'v-toaster'
Vue.use(Toaster); // Vue.use(Toaster, {timeout: 5000})
